import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=94ee98cc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=94ee98cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ee98cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94ee98cc')) {
      api.createRecord('94ee98cc', component.options)
    } else {
      api.reload('94ee98cc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=94ee98cc&scoped=true&", function () {
      api.rerender('94ee98cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/comp/DocBox.vue"
export default component.exports